import { Button } from '@cencosud-cencommerce/paris-uikit';

import { gestSignIn } from '@/modules/shared/infrastructure/mocks/guestSignIn';

export const GuestSignInButton = () => {
  const handleClick = async () => {
    await gestSignIn();
  };
  return <Button onClick={handleClick}>Entrar como invitado</Button>;
};
